// url API
export const Auth = process.env.REACT_APP_API_AUTH;
export const HR = process.env.REACT_APP_API_HR;
export const PPKB = process.env.REACT_APP_API_PPKB;
export const Asset = 'https://jsonplaceholder.typicode.com';